import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import IndexContainer from 'components/notification/index_container';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import Container from 'components/layout/container';
import TopMenu from 'components/layout/top_menu';

const Notifications = () => {
  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.notifications.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <PaginateProvider>
        <Container>
          <IndexContainer />
        </Container>
      </PaginateProvider>
    </>
  );
};

export default Notifications;
